import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css'; // Zentrale Theme-Variablen ZUERST
import './index.css';
import './i18n'; // i18next-Initialisierung vor dem ersten Render
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Wenn du die Leistung deiner App messen möchtest, kannst du eine Funktion übergeben
// um Ergebnisse zu protokollieren (z.B. reportWebVitals(console.log))
// oder an einen Analyseendpunkt senden. Weitere Informationen: https://bit.ly/CRA-vitals
reportWebVitals();
